import { useTranslation } from "@redotech/redo-i18n";
import type { ReturnProcessingInformationState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { StepImageUpload } from "./step-image-upload";

export const ReturnProcessingInformationDetails = memo(
  function ReturnProcessingInformationDetails({
    stepSelect,
    state,
    setState,
  }: StepTypeDetailsProps<ReturnProcessingInformationState>) {
    const { t } = useTranslation();
    return (
      <Flex dir="column" gap="md">
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            {t("Header")}
          </Text>
          <RedoTextInput
            placeholder={t("Step heading")}
            setValue={(header) => setState((state) => ({ ...state, header }))}
            value={state.header}
          />
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            {t("Message")}
          </Text>
          <RedoTextareaInputField
            placeholder={t("Instructions shown to the warehouse worker")}
            setValue={(message) => setState((state) => ({ ...state, message }))}
            value={state.message}
          />
        </Flex>
        <StepImageUpload
          imageUrl={state.imageUrl}
          setImageUrl={(imageUrl) =>
            setState((state) => ({ ...state, imageUrl }))
          }
        />
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            {t("Continue button text")}
          </Text>
          <RedoTextInput
            placeholder={t("Continue")}
            setValue={(continueButtonText) =>
              setState((state) => ({ ...state, continueButtonText }))
            }
            value={state.continueButtonText}
          />
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            {t("Next step")}
          </Text>
          {stepSelect({
            value: state.next,
            valueChange: (next) => setState((state) => ({ ...state, next })),
            handleIndex: 0,
          })}
        </Flex>
      </Flex>
    );
  },
);
